import { render, staticRenderFns } from "./StoryTeaserSlides.vue?vue&type=template&id=40664380&scoped=true&"
import script from "./StoryTeaserSlides.vue?vue&type=script&lang=js&"
export * from "./StoryTeaserSlides.vue?vue&type=script&lang=js&"
import style0 from "./StoryTeaserSlides.vue?vue&type=style&index=0&id=40664380&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40664380",
  null
  
)

export default component.exports